import moment from 'moment';
import _enum from '@/enum/enum';

const formatDate = (date, format = "DD/MM/YYYY hh:mm") => {
  if (!date) return null;
  return moment(date).format(format)
}

const formatMoney = (money) => {
  return new Intl.NumberFormat().format(money).replaceAll(",", ".");
};
export default { formatDate, formatMoney }

